(function () {
  var root = document.querySelector('[data-gadgetrest-home]');
  if (!root) return;
  var image = root.querySelector('[data-gr-hero-image]');
  var selectors = Array.prototype.slice.call(root.querySelectorAll('.gr-selector'));
  selectors.forEach(function (selector) {
    var preload = new Image();
    preload.src = selector.getAttribute('data-image');
    selector.addEventListener('click', function () {
      if (!image || selector.classList.contains('is-active')) return;
      selectors.forEach(function (button) {
        var active = button === selector;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      image.classList.add('is-changing');
      window.setTimeout(function () {
        image.src = selector.getAttribute('data-image');
        image.alt = selector.getAttribute('data-alt');
        image.classList.remove('is-changing');
      }, 180);
    });
  });
})();
